export default {
  id: 'tree.nodeDelegate',
  isLeaf: node => !node?.children?.length,
  getChildren: node => node?.children,
  getData: node => node?.data,
  getEventData: node => node?.eventData,
  getName: node => node?.name,
  getKey: node => node?.id,
  canDelete: node => node?.canDelete
};